const PaxsGroup = (state) => state.PaxsGroup
const DataPaxLeader = (state) => state.DataPaxLeader
const PassengerService = (state) => state.PassengerService

export default {
  PaxsGroup,
  DataPaxLeader,
  PassengerService
}
